import React from 'react';

import { Group, Stack, Text } from '@mantine/core';
import { Note } from 'types';
import { formatEventNotesContentModal } from 'utils/formatters';

import classes from './events.module.css';

interface EventNotesContentModalProps {
  note: Note;
}

const EventNotesContentModal = ({ note }: EventNotesContentModalProps): JSX.Element => {
  return (
    <Stack
      className={classes.eventCardModalContentWrapper}
      p={'md'}
      bg={'#F3F3F3'}
      sx={theme => ({ borderRadius: theme.radius.md })}
    >
      <Group position='apart'>
        <Text weight={700} size={'md'}>
          {note.title}
        </Text>
        <Text weight={400} size={'sm'}>
          {formatEventNotesContentModal(note.updatedAt)}
        </Text>
      </Group>
      <Text
        className={classes.eventCardModalInjectedHtmlWrapper}
        m={0}
        dangerouslySetInnerHTML={{ __html: note.content }}
      />
    </Stack>
  );
};

export default EventNotesContentModal;
